// extracted by mini-css-extract-plugin
export var contentBody = "_dw-9";
export var headerImage = "_dw-2";
export var imageButton = "_dw-7";
export var imageButtonIcon = "_dw-8";
export var imageHeader = "_dw-4";
export var imageHeaderText = "_dw-5";
export var imageOverlay = "_dw-3";
export var imageTitle = "_dw-6";
export var imageWrapper = "_dw-1";
export var taskList = "_dw-a";
export var widget = "_dw-0";